export const TEMPLATE_PAGE_SIZE_GRID = 18;
